<!-- services page section  -->
<div class="sevices-herobanner">
  <div class="container">
    <div class="row service-banner-container">
      <div class="col-md-7 order-mobile-2">
        <h5 class="banner-title">
          All of your Cloud Infrastructure & Software Procurement needs handled by a trusted partner.
        </h5>
      </div>
      <div class="col-md-5 order-mobile-1 text-center">
        <img src="./assets/images/services/benner_itservices.svg" alt="" class="banner-img">
      </div>
    </div>
  </div>
</div>

<!-- Browser testing  -->
<div class="service-odd" id="browsertesting">
  <div class="container">
    <div class="row service-container align-items-start">
      <div class="col-md-5 text-center">
        <img src="./assets/images/services/hw_sw_procurement.svg" alt="" class="service-img pt-4 mt-4">
      </div>
      <div class="col-md-7">
        <h6 class="service-title">Hardware & Software Procurement</h6>
        <p class="service-description">
          Qualibar works with partners to procure the right hardware and software for your business. Our service covers purchases, support, maintenance, and asset management.
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Mobile app testing  -->
<div class="service-even" id="mobiletesting">
  <div class="container">
    <div class="row service-container">
      <div class="col-md-7">
        <h6 class="service-title">Cloud Services</h6>
        <p class="service-description">
          Our partnerships with various cloud vendors ensure that you receive the best price. We can assist you with cloud architecture, setup, migration, and other services.
        </p>
        <h6 class="service-subtitle mt-4">Our Specialties:</h6>
        <ul class="key-services  row">
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Cloud Consulting</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Cloud Migration</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Private Cloud Services</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Public Cloud Services</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Managed Cloud Services</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Modern Cloud Operations</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-md-5 text-center">
        <img src="./assets/images/services/cloud_services.svg" alt="" class="service-img">
      </div>
    </div>
  </div>
</div>
